<ng-container *ngIf="isDropdown; else inputTemplate">
    <select *ngIf="companies" (change)="companyChanged($event)" class="form-control form-select" [(ngModel)]="selectedCompany" [disabled]="isDisabled">
        <option *ngFor="let company of companies" [value]="company.PRCo">{{ company.PRCoNameMask }}</option>
    </select>
</ng-container>
<ng-template #inputTemplate>
    <label for="company-num">Company Number<span class="text-danger font-weight-bolder h3"> *</span></label>
    <input type="number" class="form-control" (change)="companyChanged($event)" [value]="selectedCompany" [disabled]="isDisabled"/>
</ng-template>